import React from 'react'
import {
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
  CircularProgress
} from '@mui/material'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { ProductExternalReference } from '../../../interfaces/Producto/ProductExternalReference'

interface ProductExternalReferenceFormProps {
  onSubmit: (data: ProductExternalReference) => void
  initialData?: ProductExternalReference
  isEditing?: boolean
  closeModal?: () => void
}

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(1, 'Nombre es requerido')
    .max(100, 'Nombre no puede tener más de 100 caracteres')
    .required('Nombre es requerido'),
  description: Yup.string().max(
    500,
    'La descripción no puede tener más de 500 caracteres'
  )
})

const initialValues: ProductExternalReference = {
  productExternalReferenceId: 0,
  name: '',
  description: '',
  isActive: true
}

export const ProductExternalReferenceForm: React.FC<
  ProductExternalReferenceFormProps
> = ({ onSubmit, initialData,  closeModal }) => {
  const handleSubmitWithValidation = (values: ProductExternalReference) => {
    const cleanedValues = {
      ...values,
      name: values.name.trim(),
      description: values.description.trim()
    }
    onSubmit(cleanedValues)
  }

  return (
    <Formik
      initialValues={initialData || initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmitWithValidation}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isValid,
        dirty,
        isSubmitting
      }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Field
                as={TextField}
                name='name'
                label='Nombre'
                fullWidth
                variant='outlined'
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                disabled={isSubmitting}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <Field
                as={TextField}
                name='description'
                label='Descripción'
                fullWidth
                variant='outlined'
                multiline
                rows={3}
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.description && Boolean(errors.description)}
                helperText={touched.description && errors.description}
                disabled={isSubmitting}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Field
                    as={Checkbox}
                    name='isActive'
                    checked={values.isActive}
                    onChange={handleChange}
                    color='primary'
                    disabled={isSubmitting}
                  />
                }
                label='Activo'
              />
            </Grid>

            <Grid item xs={12} display='flex' gap={2} justifyContent='flex-end'>
              {closeModal && (
                <Button
                  variant='outlined'
                  color='primary'
                  onClick={closeModal}
                  disabled={isSubmitting}
                  sx={{ borderRadius: '12px' }}
                >
                  Cerrar
                </Button>
              )}
              <Button
                type='submit'
                variant='contained'
                color='primary'
                disabled={!isValid || !dirty || isSubmitting}
                sx={{ borderRadius: '12px' }}
                startIcon={
                  isSubmitting ? (
                    <CircularProgress size={20} color='inherit' />
                  ) : undefined
                }
              >
                {isSubmitting
                  ? 'Procesando...'
                  : 'Guardar'}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
